import { createRef } from 'preact';
import { PureComponent } from 'preact/compat';

import styles from '../../DropZone.module.scss';

interface FileInputProps {
  /** Unique ID for input */
  id: string;
  /** Comma-separated list of supported MIME-types */
  accept?: string;
  /** Open file dialog */
  open?: boolean;
  /** Disable file input */
  disabled?: boolean;
  /** Callback triggered on file dialog close */
  onClose?: () => void;
  /** Callback triggered on file input change */
  onChange: (event: Event) => void;
}

export class FileInput extends PureComponent<FileInputProps> {
  private inputNodeRef = createRef<HTMLInputElement>();

  private triggerDialogOpen() {
    this.open();
    this.props.onClose && this.props.onClose();
  }

  private open() {
    if (!this.inputNodeRef.current) {
      return;
    }

    this.inputNodeRef.current.click();
  }

  componentDidMount() {
    this.props.open && this.triggerDialogOpen();
  }

  componentDidUpdate() {
    this.props.open && this.triggerDialogOpen();
  }

  render() {
    const { onChange, ...props } = this.props;

    return (
      <div className={styles.FileInput}>
        <input
          ref={this.inputNodeRef}
          autoComplete="off"
          type="file"
          onChange={onChange}
          {...props}
        />
      </div>
    );
  }
}
